import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '01',
    title: 'Descarga la guía',
    description: 'y aplica el Protocolo de Enfriamiento de 5 minutos esta misma noche.'
  }, {
    number: '02',
    title: 'Organiza tu "Cueva de Sueño"',
    description: 'siguiendo el checklist técnico de materiales y luz.'
  }, {
    number: '03',
    title: 'Usa el Protocolo de Rescate',
    description: "si llegas a despertar en la madrugada para 'apagar' tu mente al instante."
  }];
  return <section ref={ref} className="w-full bg-[#f8f4e8] py-20 md:py-32" data-id="element-124">
      <div className="max-w-5xl mx-auto px-6" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-126">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#0f172a] text-center" data-id="element-127">
            Cómo Funciona
          </h2>

          <div className="space-y-8" data-id="element-128">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="flex gap-6 items-start bg-white p-8 rounded-lg shadow-lg" data-id="element-129">
                <div className="flex-shrink-0 w-16 h-16 bg-[#d4a853] rounded-full flex items-center justify-center" data-id="element-130">
                  <span className="text-2xl font-bold text-[#0f172a]" data-id="element-131">
                    {step.number}
                  </span>
                </div>
                <div className="space-y-2 flex-1" data-id="element-132">
                  <h3 className="text-2xl font-semibold text-[#0f172a]" data-id="element-133">
                    {step.title}
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed" data-id="element-134">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}